<template>
    <div>
        <home-section-title :text="title" />
        <v-sheet color="transparent" class="pt-1 px-2 container" height="110">
            <v-slide-x-reverse-transition>
                <div
                    class="swiper-touch-guard"
                    @touchstart.stop
                    @touchmove.stop
                    @touchend.stop
                    >
                    <swiper ref="swiper" class="swiper justify-lg-center justify-md-center" :options="swiperOption">
                        <swiper-slide v-for="(item, i) in orderedItems" :key="i" >
                            <home-gallery-item :item="item" :id="item.id" :streamIcon="streamIcon" :circle="circle" @click="refClass ? handleStreamsButtonClick(item) : handleClickGalleryItem(i)"/>
                        </swiper-slide>
                    </swiper>
                </div>
            </v-slide-x-reverse-transition>
        </v-sheet>
    </div>
</template>

<script>
import HomeSectionTitle from '@/components/app/home/HomeSectionTitle';
import HomeGalleryItem from '@/components/app/home/HomeGalleryItem';
import { mapActions } from "vuex";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import _ from "lodash";

export default {
    name: "HomeSwiper",
    components: {
        HomeSectionTitle,
        HomeGalleryItem,
        Swiper,
        SwiperSlide
    },
    props: {
        title: {
            type: String,
            required: true
        },
        items: {
            type: [Array, Object],
            default: () => []
        },
        activeIndex: {
            type: Number,
            default: 0
        },
        refClass: {
            type: Boolean,
            default: false
        },
        circle: {
            type: Boolean,
            default: false
        },
        streamIcon: {
            type: Boolean,
            default: false
        },
    },
    mounted() {
        this.swiper = this.$refs.swiper.$swiper;
        this.swiper.on('slideChange', () => {
            this.$emit('slideChange', this.swiper.activeIndex);
        });
    },
    watch: {
        activeIndex(newVal) {
            if (this.swiper && this.swiper.activeIndex !== newVal) {
                this.swiper.slideTo(newVal);
            }
        }
    },
    computed: {
        orderedItems() {
            return _.orderBy(this.items, 'order', 'desc')
        },
        orderedItemsHasStories() {
            return this.orderedItems.filter((item) => {
                return item.has_stories > 0
            })
        },
    },
    data: () => ({
        swiperOption: {
            slidesPerView: 'auto',
            freeMode: true,
            cssMode: true,
        },
    }),
    methods: {
        ...mapActions([
            "setOtherUser",
            "setOtherUserBySlug",
        ]),
        handleClickGalleryItem(index) {
            this.$emit('click',{
                items: this.orderedItemsHasStories,
                index: index,
            })
        },
        async handleStreamsButtonClick(item) {
            const promise =
                typeof this.$route.params.slug !== "undefined"
                    ? this.setOtherUserBySlug(item.slug)
                    : this.setOtherUser(item.id);

            await promise.catch(() => {
                this.$router.push({ name: "404" });
            });

            if (!!item.slug) {
                this.$router.push({
                    name: "otherUser.profile.viewStreams",
                    params: { slug: item.slug },
                    query: { fromHome: true },
                });
                return;
            }
        },
    }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/settings';

.swiper {
    -webkit-transform: translateZ(0);

    &-slide {
        display: flex;
        justify-content: center;
        width: auto;
        margin-left: map-deep-get($utilities, 'margin-left', values, 0);
        -webkit-transform: translateZ(0);

        @media #{map-get($display-breakpoints, 'sm-and-down')} {
            width: 33.33%;
            margin-left: map-deep-get($utilities, 'margin-left', values, 0);
        }

        &:last-child {
            margin-right: map-deep-get($utilities, 'margin-right', values, 4);

            @media #{map-get($display-breakpoints, 'sm-and-down')} {
                margin-right: map-deep-get($utilities, 'margin-right', values, 4);
            }
        }
    }
}
</style>
